import React from 'react';
import ProcessComp  from '../components/processComp';
import Icon from '../../../components/icon/icon';
import { NumberOne, NumberTwo, NumberThree, Calendar, Ticket, UserFocus } from '@phosphor-icons/react'; 

const Process = () => {

  const stepsData = [
    {
      step: 'Add basic details about your event',
      stepIcon:<div  className='w-9 h-9 text-white label-16 flex items-center justify-center bg-primary rounded-full text-center ' >1</div>,
      icon: <Icon type="square">
              <Calendar size={24} color='#101010' />
            </Icon>,
    },
    {
      step: 'Add Ticket categories',
      stepIcon:<div   className='w-9 h-9 text-white label-16 flex items-center justify-center bg-primary rounded-full text-center ' >2</div>,
      icon: <Icon type="square" >
              <Ticket size={24} color='#101010' />
            </Icon>, 
    },
    {
      step: 'Booking details and publish',
      stepIcon:<div   className='w-9 h-9 text-white label-16 flex items-center justify-center bg-primary rounded-full text-center ' >3</div>,
      icon: <Icon type="square" >
              <UserFocus size={24} color='#101010' />
            </Icon>, 
    },
  ];

  return (
    <div className="min-h-screen bg-light px-6 py-[100px] flex flex-col items-center gap-16">
      <div className="flex flex-col gap-6 text-center m-auto my-0">
        <div className=" text-black  heading-36 md:text-6xl md:font-bold  leading-snug md:w-[55%] justify-center m-auto">
          List your event in <span className="text-primary">3 simple steps</span>
          </div>
        <div className="text-18">Ticketing that doesn’t suck – Seriously</div>
    
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
        {stepsData.map((stepItem, index) => (
          <ProcessComp  
            key={index}
            icon={stepItem.icon}
            stepIcon={stepItem.stepIcon}
            step={stepItem.step}
          />
        ))}
      </div>
    </div>
  );
};

export default Process;
